module.exports = __webpack_public_path__ + "static/media/wx.8a517f2e.png";